import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { Panel, PanelHeader, PanelBody } from './../../components/admin/panel/panel';

class Home extends React.Component {

    state = {
        redirect: true
    }

    render() {
        const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/admin/banners/home/main' />;
        }

        return (
            <div>
                <ol className="breadcrumb pull-right">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active">Active Page</li>
                </ol>
                <h1 className="page-header">Home <small>header small text goes here...</small></h1>
                <Panel>
                    <PanelHeader>Panel Title here</PanelHeader>
                    <PanelBody>
                        Panel Content Here
		            </PanelBody>
                </Panel>
            </div>
        )
    }
}

export default connect()(Home);



// WEBPACK FOOTER //
// ./src/pages/admin/home.js